(function ($) {
    jQuery.fn.showModal = function (options) {
        if (this.length <= 0) {
            return;
        }
        var self = this;

        options = $.extend({
            useModalMask: true,
            noScroll: false,
            elCloseBtn: ".ssg-toggle-close",
            opacity: "0.8"
        }, options);

        var _createModalMask = function () {
            var mask = $('<div class="ssg-modal-mask">').css({
                'width': '100%',
                'height': '100%',
                'position': 'fixed',
                'top': 0,
                'left': 0,
                'display': '',
                'z-index': 10000,
                'background-color': 'rgba(0,0,0,' + options.opacity + ')'
            });

            if (options.useModalMask) {
                $('body').append(mask);
            }
        };

        var _showModalLayer = function () {
            if (!self.parent('div').hasClass('ssg-modal-layer')) {
                var lywrap = $('<div class="ssg-modal-layer">').css({
                    'position': 'absolute',
                    'width': '100%',
                    'text-align': 'center',
                    'z-index': 10001
                });
                self.wrap(lywrap);
            }

            if (options.noScroll) {
                document.addEventListener('touchmove', function (e) { e.preventDefault(); }, false);
            }

            self.show();
        };

        var _hideModalLayer = function () {
            self.hide();
            $('.ssg-modal-mask').remove();

            if (options.noScroll) {
                document.removeEventListener('touchmove', function (e) { e.preventDefault(); });
            }
        };

        var _resetPosition = function () {
            self.parent().css({
                left: $(window).width() / 2 - self.parent().outerWidth() / 2,
                top: Math.max($(window).scrollTop() + $(window).height() / 2 - self.parent().outerHeight() / 2, 0)
            });
        };

        $(self).find(options.elCloseBtn).on('click', function (e) {
            e.preventDefault();
            _hideModalLayer();
        });

        $(window).on('resize orientationchange', function (e) {
            _resetPosition();
        });

        $(self).on('click', function (e) {
            _resetPosition();
        });

        var _init = function () {
            _createModalMask();
            _showModalLayer();
            _resetPosition();
        };

        _init();
    };

    $.fn.hideModal = function (options) {
        if (this.length <= 0) {
            return;
        }

        options = $.extend({
            hideModalMask: true
        }, options);

        this.hide();

        if (options.hideModalMask) {
            $('.ssg-modal-mask').remove();
        }

        $('body').css('overflow-y', 'auto');
    };
})(jQuery);